import { Outlet } from "react-router-dom";
import Layout from "../components/Layout";
import { ThemeProvider } from "../context/Theme";
import { EstablecimientoProvider } from "../context/Establecimiento";
import { CatalogProvider } from "../context/Catalog";

export default function MainPage({ ...props }) {
  return (
    <ThemeProvider>
      <CatalogProvider>
        <Layout id="mainPage">
          <EstablecimientoProvider>
            <Outlet />
          </EstablecimientoProvider>
        </Layout>
      </CatalogProvider>
    </ThemeProvider>
  );
}
